<template>
  <div>
    <x-grid :id="'employeeTable'"
            :rowId="rowId"
            :pager-config="pagerConfig"
            :form-config="formConfig"
            :url="url"
            :columns="columns"
            :cell-click="chooseRow"
            @returnForm="returnForm"
            ref="grid"
    >
    </x-grid>
  </div>
</template>

<script>
import XGrid from '@/components/grid/XGridPop'
import {GridPopMixin} from "@/utils/GridPopMixin";
import api from '@/services/api'

const fac = XGrid.factory;

//列表接口
const url = api.comm.USER + '/popSelectUserList';
//主键
const rowId = 'userId';
//方法表名 和表单中 方法判断名称一致
const tableName = 'employeeTable';
//表格需要多选还是单选
const tableType = 'radio';

//列
const columns = [
  fac.makeColumnDefault(tableType),
  fac.makeColumn({
    type: 'seq',
    title: '序号',
    width: 60,
  }),
  fac.makeColumn("userName", "姓名", 120),
  fac.makeColumn("userNo", "用户账号", 160),
  fac.makeColumn("deptName", "部门", 160),
  fac.makeColumn("mobile", "手机号", 160),
]

// 筛选条件
const formConfig = fac.makeFormConfig(columns, [
  {field: 'userName'},
  {field: 'deptName'},
])


const pagerConfig = fac.makePagerConfig();

export default {
  mixins: [GridPopMixin],
  data() {
    return {
      tableName,
      tableType,
      columns,
      rowId,
      url,
      formConfig,
      pagerConfig,
    }
  },
  methods: {}
}
</script>

<style scoped>
</style>